import {
  DebugRecordDetail,
  DebugRecords,
  EntranceRecordDetail,
} from "@admin/pages/data-records";
import type { RouteObject } from "react-router-dom";

const debugList = [
  { index: true, element: <DebugRecords /> },
  { path: ":id", element: <DebugRecordDetail /> },
] satisfies RouteObject[];
const entranceList = [
  { index: true, element: <DebugRecords /> },
  { path: ":id", element: <EntranceRecordDetail /> },
];
export const serviceRecordsRoute = [
  { path: "/entranceeRecords", children: entranceList },
  { path: "/debugRecords", children: debugList },
] satisfies RouteObject[];
